import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { moviesUpdateItem, movieExtensionsUpdateItem, movieExtensionsAddItemToReset } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import { 
    PROGRAM_CLI_MOVIES_ITEMS, 
    PROGRAM_PERFORMANCES, 
    PROGRAM_ATTRIBUTES, 
    PROGRAM_MOVIEEXTENSIONS_ITEMS, 
    PROGRAM_MOVIEMAPPING_ITEMS,
    PROGRAM_PY_MOVIES_ITEMS, 
    PROGRAM_KH_MOVIES_ITEMS,
    PROGRAM_COMP_MOVIES_ITEMS,
    PROGRAM_META_MOVIES_ITEMS,
    PROGRAM_MOVIEEXTENSIONS_ITEMS_TO_RESET,
    PROGRAM_DIESEL_MOVIES_ITEMS,
    PROGRAM_CORTEC_MOVIES_ITEMS,
} from '../../../constants/state'
import EditMovie from '../present/EditMovie'
import { ORIGIN_DATA_PROVIDER, ORIGIN_PM } from '../../../constants/metaMovieOrigins'

const mapStateToProps = (state, ownProps) => ({
    movies: getData(state, PROGRAM_CLI_MOVIES_ITEMS),
    performances: getData(state, PROGRAM_PERFORMANCES),
    attributes: getData(state, PROGRAM_ATTRIBUTES),
    movieExtensionsItems: getData(state, PROGRAM_MOVIEEXTENSIONS_ITEMS),
    movieExtensionsToReset: getData(state, PROGRAM_MOVIEEXTENSIONS_ITEMS_TO_RESET),
    movieMappings: getData(state, PROGRAM_MOVIEMAPPING_ITEMS),
    metaMovie: getData(state, [PROGRAM_META_MOVIES_ITEMS, ownProps.itemId]),
    pyMovies: getData(state, PROGRAM_PY_MOVIES_ITEMS),
    dieselMovies: getData(state, PROGRAM_DIESEL_MOVIES_ITEMS),
    khMovies: getData(state, PROGRAM_KH_MOVIES_ITEMS),
    compMovies: getData(state, PROGRAM_COMP_MOVIES_ITEMS),
    cortecMovies: getData(state, PROGRAM_CORTEC_MOVIES_ITEMS)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: (itemData, metaData) => {
        const updateLocal = !ownProps.updateRemote
        
        dispatch(moviesUpdateItem(ownProps.itemId, itemData.movie, itemData.attributes, metaData, updateLocal))
    },
    onUpdateExtension: (pk, extension, data) => {
        dispatch(movieExtensionsUpdateItem(pk, extension, data))
    },
    onResetExtension: (pk, extension) => {
        dispatch(movieExtensionsUpdateItem(pk, extension, null))
        dispatch(movieExtensionsAddItemToReset(pk))
    }
})

class EditMovieContainer extends Component {
    constructor(props) {
        super(props)

        const { metaMovie } = this.props

        this.state = {
            metaData: metaMovie ? metaMovie : false,
            movieExtensionsToReset: []
        }

        this.setMeta = this.setMeta.bind(this)
        this.onChangeField = this.onChangeField.bind(this)
        this.onResetField = this.onResetField.bind(this)
        this.getSourceMovies = this.getSourceMovies.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        const {  metaData } = this.state
        const { metaMovie } = nextProps
        
        this.initMeta( metaData, metaMovie)
    }

    getSourceMovies(sourceMoviesByItemId) {
        const { khMovies, compMovies, pyMovies, dieselMovies, cortecMovies } = this.props
        const cliMovieRelevantSourceMovies = {}

        if(sourceMoviesByItemId) {
            sourceMoviesByItemId.map(movieSource => {
                _.keys(movieSource).map(movieSourceKey => {
                    const movieSourceMovieId = movieSource[movieSourceKey]
        
                    if(movieSourceKey === 'Kinoheld') {
                        cliMovieRelevantSourceMovies[movieSourceMovieId] = khMovies[movieSourceMovieId]
                    } else if(movieSourceKey === 'Compeso') {
                        cliMovieRelevantSourceMovies[movieSourceMovieId] = compMovies[movieSourceMovieId]
                    } else if(movieSourceKey === 'DieselV2') {
                        cliMovieRelevantSourceMovies[movieSourceMovieId] = dieselMovies[movieSourceMovieId]
                    } else if(movieSourceKey === 'Cortec') {
                        cliMovieRelevantSourceMovies[movieSourceMovieId] = cortecMovies[movieSourceMovieId]
                    } else {
                        cliMovieRelevantSourceMovies[movieSourceMovieId] = pyMovies[movieSourceMovieId]
                    }
                })
            })
        }

        return cliMovieRelevantSourceMovies
    }

    initMeta(metaData, metaMovie) {
        if(!metaData) {
            this.setState({
                metaData: metaMovie
            })
        }
    }

    setMeta(key, origin) {
        const { metaData } = this.state

        if(origin !== metaData[key]) {
            this.setState({
                metaData: {
                    ... metaData,
                    [key]: origin
                }
            })
        }
    }

    onChangeField(key) {
        this.setMeta(key, ORIGIN_PM)
    }

    onResetField(key) {
        this.setMeta(key, ORIGIN_DATA_PROVIDER)
    }

    render() {
        const { itemId, movies, movieMappings, performances, attributes, closePagePath, onUpdateItem, movieExtensionsItems, movieExtensionsToReset, onUpdateExtension, onResetExtension } = this.props
        const { metaData } = this.state
        const movieExist = movies && movies.hasOwnProperty(itemId) && movies[itemId]

        const sourceMoviesByItemId = movieExist && !_.isEmpty(movieMappings) ? movieMappings[itemId].source : null
        const cliMovieRelevantSourceMovies = this.getSourceMovies(sourceMoviesByItemId)
        const sourceData = cliMovieRelevantSourceMovies ? cliMovieRelevantSourceMovies[Object.keys(cliMovieRelevantSourceMovies)[0]] : {}
        let sourceDataProvider = null
        
        sourceMoviesByItemId && sourceMoviesByItemId.map(movieSource => {
            _.keys(movieSource).map(movieSourceKey => {
                const movieSourceMovieId = movieSource[movieSourceKey]
                if(movieSourceMovieId === sourceData.pk) {
                    sourceDataProvider = movieSourceKey
                }
            })
        })

        return <EditMovie
            itemId={itemId}
            closePagePath={closePagePath}
            movies={movies}
            metaData={metaData}
            sourceData={sourceData}
            movieExtensionsItems={movieExtensionsItems}
            movieExtensionsToReset={movieExtensionsToReset}
            performances={performances}
            attributes={attributes}
            sourceDataProvider={sourceDataProvider}
            movieExist={movieExist}
            sourceMoviesByItemId={sourceMoviesByItemId}
            cliMovieRelevantSourceMovies={cliMovieRelevantSourceMovies}
            onUpdateItem={onUpdateItem}
            onUpdateExtension={onUpdateExtension}
            onResetExtension={onResetExtension}
            onChangeField={this.onChangeField}
            onResetField={this.onResetField}
        />
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditMovieContainer)